import * as React from 'react';

const SvgCart = React.forwardRef(({ size = 24, ...props }, ref) => (React.createElement("svg", { "data-testid": "svg-cart", xmlns: "http://www.w3.org/2000/svg", width: size, height: size, fill: "none", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.07 3a1 1 0 0 0 0 2h1.374l3.11 12h9.56a2 2 0 0 0 1.931-1.48l1.881-7A2 2 0 0 0 18.995 6H6.77l-.778-3zm6.032 12L7.288 8h11.707l-1.881 7z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "currentColor", d: "M11 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0M19 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0" }))));
SvgCart.displayName = 'SvgCart';

export { SvgCart };
